/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR) */
/** Opaque lifecycle notice schema; host shells own all persistence and events. */
export const WORKSPACE_EPOCH_KEY = 'qubepro_workspace_epoch_v1';
export const WORKSPACE_CHANNEL = 'qubepro-workspace-v1';
export const WORKSPACE_CONTEXT_CHANGED_EVENT = 'qubepro:workspace-context-changed';
export const WORKSPACE_SIGN_OUT_EVENT = 'qubepro:workspace-sign-out';
export type WorkspaceNotice = { epoch: string; phase: 'begin' | 'settled' | 'signed-out' };
export function parseWorkspaceNotice(value: unknown): WorkspaceNotice | null {
  if (typeof value !== 'string') return null;
  const match = /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}):(begin|settled|signed-out)$/i.exec(value);
  return match ? { epoch: match[1], phase: match[2] as WorkspaceNotice['phase'] } : null;
}
